/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_EdgeInputs */

const cs_workflow_edge = /** @type {(inputs: Workflow_EdgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spojení`)
};

const en_workflow_edge = /** @type {(inputs: Workflow_EdgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edge`)
};

/**
* | output |
* | --- |
* | "Edge" |
*
* @param {Workflow_EdgeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_edge = /** @type {((inputs?: Workflow_EdgeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_EdgeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_edge(inputs)
	return cs_workflow_edge(inputs)
});